import { devtools } from 'zustand/middleware'
import { DEVTOOLS_ENABLED } from '../../consts'
import { create } from '../../feat/appState/resetState'

type THeaderHeight = 156 | 86

type TScrollState = {
    useBackAnimation: boolean
    setUseBackAnimation: (bool: boolean) => void
    atTop: boolean
    atBottom: boolean | null
    setAtTop: (bool: boolean) => void
    setAtBottom: (bool: boolean) => void
    scrollBehavior: 'smooth' | 'auto' | 'initial'
    setScrollBehaviour: (scrollBehav: 'smooth' | 'auto' | 'initial') => void
    scrollIntoView: (ref: React.MutableRefObject<any>) => void
    toggleHeader: () => void
    headerHeight: THeaderHeight
}

export const useScrollContext = create<TScrollState>()(
    devtools(
        (set, get) => ({
            useBackAnimation: false,
            atTop: true,
            atBottom: true,
            scrollBehavior: 'smooth',
            headerHeight: 156,
            setUseBackAnimation: (bool: boolean) => {
                set(() => ({
                    useBackAnimation: bool,
                }))
            },
            setAtTop: (bool: boolean) => {
                set(() => ({
                    atTop: bool,
                    headerHeight: bool ? 156 : 86,
                }))
            },
            setAtBottom: (bool: boolean) => {
                set(() => ({
                    atBottom: bool,
                }))
            },
            setScrollBehaviour: (
                scrollBehav: 'smooth' | 'auto' | 'initial'
            ) => {
                set(() => ({
                    scrollBehavior: scrollBehav,
                }))
            },
            scrollIntoView: (
                containerRef: React.MutableRefObject<HTMLDivElement>
            ) => {
                requestAnimationFrame(() => {
                    if (!containerRef?.current?.getBoundingClientRect) {
                        return
                    }

                    const containerRect =
                        containerRef.current.getBoundingClientRect()
                    const windowHeight = window.innerHeight

                    const thresholdPercentage = 40
                    const threshold = (thresholdPercentage / 100) * windowHeight
                    const isNearBottom =
                        containerRect.bottom + threshold >= windowHeight

                    if (isNearBottom) {
                        containerRef.current.scrollIntoView({
                            behavior: 'auto',
                            block: 'start',
                        })
                    }
                })
            },
            toggleHeader: () => {
                set({ headerHeight: get().headerHeight === 156 ? 86 : 156 })
            },
        }),
        {
            enabled: DEVTOOLS_ENABLED,
            name: 'scrollState',
        }
    )
)
